"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketEncryptionOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketEncryptionOutput.js.map